import { PictureAsPdf } from "@mui/icons-material";
import Button from "e.sic-platform.webclient/src/components/button/Button";
import useThemeService from 'e.sic-platform.webclient/src/services/theme-service/ThemeService';

export default function PdfButton(props: {disabled?: boolean, onClick?(): void}) {
  const { themeClass } = useThemeService();

  return (
    <Button
      id="pdf"
      onClick={props.onClick}
      disabled={props.disabled}
      icon={{
        svg: PictureAsPdf,
        textKey: "general.export.pdf",
        textClass: "actions-header-button-label",
        className: themeClass(["icon-mui"]),
      }}
    />
  );
}
